import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemConfigurationRoutingModule } from './system-configuration-routing.module';
import { SystemConfigurationComponent } from './system-configuration.component';
import { AngularMaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [
    SystemConfigurationComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    SystemConfigurationRoutingModule
  ]
})
export class SystemConfigurationModule { }
